import Playable from "./playable";
import PlayableItemNull from "../playables/items/null";

/**
 * PlayableDefault
 *
 * Needs to implement the Playable API
 */
class PlayableDefault extends Playable {
  constructor(props) {
    super(props);
    this.item = new PlayableItemNull();
    this.set(props);
  }

  set(nextProps) {
    this.props = nextProps;
    this.onUpdate();
  }

  onUpdate() {
    const { state } = this.props;
    let { status } = state.player;
    this.item.set({ status });
  }

  currentItem() {
    return this.item;
  }
}

export default PlayableDefault;
